module.exports = __webpack_public_path__ + "media/components/assets/img/bg/torp-airport-flyo-2d13c791440cba6be317dc250165d3c8.svg";